import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { UtilsService } from 'src/app/services/utils.service';
import { LoaderService } from 'src/app/services/loader.service';
import { isEmpty, forEach, remove, cloneDeep} from 'lodash';
import { SuccessComponent } from '../success/success.component';
import { MANAGE_LINE_CONST, COMMON_CONSTANTS, ANALYTICS, ENTITLEMENT_ACTIVITYNAMES } from '../../../common/core/common.constants';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { IndividualAlertModalComponent } from '../individual-alert-modal/individual-alert-modal';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'src/app/services/utils';
import { PDLService } from 'src/app/services/pdl-service.service';
@Component({
  selector: 'app-change-number',
  templateUrl: './change-number.component.html',
  styleUrls: ['./change-number.component.scss']
})
export class ChangeNumberComponent implements OnInit, OnDestroy {

  checkBoxDisabled;
  selectsubmitCheckBox = false;
  selectedLines: any = '';
  individually = false;
  allLineOpenModal = true;
  totalNumberDetails: any = [0];
  changeNumberLines: any = [];
  IndividualLine: any;
  ban: any;
  dealerCode: any;
  authoringContentData: any;
  checkedRadioButton: string;
  panelOpenState = false;
  successModalRef: any;
  nonActiveLines = [];
  isLineDetailsWindow: boolean;
  isEndUser = this.utilsSvc.IsEndUser();
  approvalActivitiesList : any;
  isApprovalRequired : any;
  isSubmitReadOnly : boolean;
  ngbModalOptions:NgbModalOptions;
  chargeAdvisementFlag: boolean;

  constructor(public manageLineService: ManageLineService, private _cacheSvc: HttpCacheService,
    public utilsSvc: UtilsService, private _loaderSvc: LoaderService, private modalService: NgbModal,
    private pdlService: PDLService
  ) {
    this.isLineDetailsWindow = false;
  }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().changeNumberAuthoring;
    this.checkedRadioButton = this.authoringContentData.assignAll;
    this.individually = Boolean(this.selectedLines.length === 1);
    this.isSubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE);
    this.checkBoxDisabled = true;
    this.manageLineService.changeNumberFlowResponseBody = [];
    this.selectedLines[0].expendFlagValue = true;
    this.manageLineService.notifyChangeNumberFlow.subscribe((response: any) => {
      switch (response.id) {
        case MANAGE_LINE_CONST.ENABLE_CHECKBOX:
          this.checkBoxDisabled = this.manageLineService.isCheckBoxDisabled;
          break;
        case MANAGE_LINE_CONST.ASSIGN_INDIVIDUAL :
          this.allLineOpenModal = false;
          break;
        case MANAGE_LINE_CONST.SUCCESS_VALIDATOR:
          this.selectedLines[response.index].succesValidator = true;
          this.selectedLines[response.index].errorValidator = false;
          break;
        case MANAGE_LINE_CONST.ERROR_VALIDATOR:
          this.selectedLines[response.index].errorValidator = true;
          this.selectedLines[response.index].succesValidator = false;
          break;
        case MANAGE_LINE_CONST.DISABLE_CHECKBOX:
          this.checkBoxDisabled = true;
          this.selectsubmitCheckBox = false;
          this.selectedLines = forEach(this.selectedLines, (line) => {
            line.errorValidator = false;
          });
          break;
        case  MANAGE_LINE_CONST.OVERRIDE_CHANGES:
          this.manageLineService.changeNumberFlowResponseBody = [];
          this.manageLineService.storeMultiLineData = null;
          this.manageLineService.notifyChangeNumberFlow.next({ id: 'emptyForm' });
          this.selectedLines = forEach(this.selectedLines, (line) => {
            line.succesValidator = false;
            line.errorValidator = false;
          });
          this.allLineOpenModal = false;
          break;
        case MANAGE_LINE_CONST.DISCARD_CHANGES:
          this.checkedRadioButton = this.authoringContentData.assignAll;
          break;
        case MANAGE_LINE_CONST.CHANGE_NUMBER_REASON:
          this.setAdvisementMsgFlag(response?.reasonCode);
          break;
        default:
          break;
      }
    });
    if (this.selectedLines.length > 0) {
      for (const line of this.selectedLines) {
        if (line.statusCode !==  MANAGE_LINE_CONST.ACTIVE) {
          this.nonActiveLines.push(line);
        } else {
          line.succesValidator = false;
          line.errorValidator = false;
          line.msgShowOnPanel = true;
          this.changeNumberLines.push(line);
        }
      }
    }
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: MANAGE_LINE_CONST.CHANGE_NUMBER_CTA_TXT
    });
  }
  removeNumber(index) {
    this.manageLineService.notifyChangeNumberFlow.next({ id: 'removeSelection', msisdn: this.selectedLines[index].msisdn });
    remove(this.manageLineService.changeNumberFlowResponseBody as any[], (item: any) => {
      return item.oldMsisdn === this.selectedLines[index].msisdn;
    });
    this.selectedLines.splice(index, 1);
    if (this.selectedLines.length === 0) {
      this.manageLineService.close();
    }
  }
  getModalValue(modalValue) {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    if (modalValue.target.value === MANAGE_LINE_CONST.ASSIGN_ALL && this.manageLineService.callCounter > 0) {
      return;
    }
    if (modalValue.target.value !== MANAGE_LINE_CONST.ASSIGN_ALL && !isEmpty(this.manageLineService.storeMultiLineData)) {
      this.successModalRef = this.modalService.open(IndividualAlertModalComponent,this.ngbModalOptions);
      return;
    }
    this.allLineOpenModal = Boolean(modalValue.target.value === MANAGE_LINE_CONST.ASSIGN_ALL);

    if (!this.allLineOpenModal && this.manageLineService.changeNumberFlowResponseBody.length >= 1) {
      this.successModalRef = this.modalService.open(IndividualAlertModalComponent, this.ngbModalOptions);
    } else {
      this.manageLineService.callCounter = 0;
    }
  }

  submitChangeNumberRequest() {
    if (this.isEndUser && environment.ENABLE_AHUB_FLOW) {
      this.approvalActivitiesList = JSON.parse(this._cacheSvc.getFromSessionStorage('approvalFlags'));
      this.checkApprovalRequired();
    }
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };

    if (this.individually) {
      const body = cloneDeep(this.manageLineService.changeNumberFlowResponseBody[0]);
      body['mobileNumber'] = body['oldMsisdn'];

      delete body['oldMsisdn']
      delete body['orgId']

      this.manageLineService.changeNumberRequest(body).subscribe((data) => {
        this.manageLineService.close();
        if (!this.isEndUser || (this.isEndUser && this.isApprovalRequired === COMMON_CONSTANTS.DIGITS.ZERO)) {
          this.openNoApprovalReqSuccessModal(data);
        } else if (this.isEndUser && this.isApprovalRequired === COMMON_CONSTANTS.DIGITS.ONE) {
          this.openEndUserSuccessModal(data);
        }
      }, (error) => {
        this.manageLineService.close();
        this.utilsSvc.errorHandling(error);
      });
    } else {
      const requestPayLoad = {
        'targetServiceName': 'change-msdn',
        'ban': this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
        'requests': this.manageLineService.changeNumberFlowResponseBody

      };
      this.manageLineService.bulkChangeNmberProcessor(requestPayLoad).subscribe((data) => {
        this.manageLineService.close();
        const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
        successModalRef.componentInstance.bulkOrderStatus = data;
        successModalRef.componentInstance.header = this.authoringContentData.successModalTitle;
        if (!isNullOrUndefined(data && data.token)) {
          successModalRef.componentInstance.token = data.token;
        }
        successModalRef.componentInstance.bulkUploadFlow = false;
        successModalRef.componentInstance.isConfirmationPopup = false;


      }, (error) => {
        this.manageLineService.close();
        this.utilsSvc.errorHandling(error);
      });
    }
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: this.authoringContentData.SubmitChangeBtn,
      assetType: ANALYTICS.BUTTON,
      modalName:'',
      userSelection:''
    });
  }
  checkApprovalRequired(){
    if (!isNullOrUndefined(this.approvalActivitiesList)) {
      for (let approval of this.approvalActivitiesList) {
        if (approval.FlagName === COMMON_CONSTANTS.IS_CHANGENUMBER_APPROVAL) {
          this.isApprovalRequired = approval.FlagValue;
        }
      }
    }
  }

  closePopupTagging(){
    this.modalService.dismissAll();
    this._loaderSvc.stop();
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.CLOSE,
      modalName: MANAGE_LINE_CONST.CHANGE_NUMBER_CTA_TXT,
    });
  }

  ngOnDestroy() {
    this.manageLineService.storeMultiLineData = null;
    this.manageLineService.callCounter = 0;
  }
  // when expansion panel is closed showing message on accordian
  expansionPanelClosed(line) {
    line.msgShowOnPanel = true;
    line.expendFlagValue = false;
  }
  // when expansaion panel is open hiding message accordian
  expansionPanelOpened(line, index) {
    line.msgShowOnPanel = false;
    line.expendFlagValue = true;
  }
  // method for setting step for accordian
  setStep(i) {
    this.manageLineService.setStep(i);
  }
  nextStep(line) {
    const nextIndex = this.selectedLines.findIndex(item => item.msisdn === line.msisdn);
    if (this.selectedLines.length -1  > nextIndex) {
      this.selectedLines[nextIndex + 1].expendFlagValue = true;
    }
    this.selectedLines[nextIndex ].expendFlagValue = false;
  }


  openEndUserSuccessModal(changeNumberRes: any) {
    const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
    successModalRef.componentInstance.orderStatus = changeNumberRes;
    successModalRef.componentInstance.header = this.authoringContentData.successModalTitle;
    successModalRef.componentInstance.modalBodyContent = this.authoringContentData.approvalTxt;
    successModalRef.componentInstance.isConfirmationPopup = true;
    successModalRef.componentInstance.isChangeNumber = true;
    successModalRef.componentInstance.processText = this.authoringContentData.processTxt;
    successModalRef.componentInstance.isLineDetailsWindow = this.isLineDetailsWindow;
  }

  openNoApprovalReqSuccessModal(changeNumberRes: any) {
    const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
    successModalRef.componentInstance.orderStatus = changeNumberRes;
    successModalRef.componentInstance.header = this.authoringContentData.successModalTitle;
    successModalRef.componentInstance.modalBodyContent = this.authoringContentData.confirmationMsgTxt;
    successModalRef.componentInstance.bulkUploadFlow = false;
    successModalRef.componentInstance.isLineDetailsWindow = this.isLineDetailsWindow;
  }

  setAdvisementMsgFlag(reasonCode) {
    this.chargeAdvisementFlag = false;

    if (MANAGE_LINE_CONST.SHOW_CHARGE_ADVISEMENT_MSG_REASON_CODES.has(reasonCode)) {
      this.chargeAdvisementFlag = true
    }
    for(const data of this.manageLineService.changeNumberFlowResponseBody) {
      if (MANAGE_LINE_CONST.SHOW_CHARGE_ADVISEMENT_MSG_REASON_CODES.has(data?.reasonId)) {
        this.chargeAdvisementFlag = true;
      }
    }
  }
}
